import { RULES_CONSTANTS } from '@nextiva/global-store';
import routes from './routes';

const {
  PLATFORM_ADMIN: { PLATFORM_ADMIN, SUPER_ADMIN, APP_ACCESS },
} = RULES_CONSTANTS;

export const userDropdownOptions = [
  {
    label: 'Administration Tools',
    href: '/apps/home/#/admin',
    rules: [
      `${PLATFORM_ADMIN}.${SUPER_ADMIN}`,
      `${PLATFORM_ADMIN}.${APP_ACCESS}`,
    ],
    isAdminTool: true,
  },
  {
    label: 'Billing',
    href: '/apps/billing/#/landing/payment',
    rules: [
      `${PLATFORM_ADMIN}.${SUPER_ADMIN}`,
      `${PLATFORM_ADMIN}.${APP_ACCESS}`,
    ],
  },
  {
    label: 'Licensing',
    href: '/apps/platform-admin/#/licensing/licensing',
    rules: [
      `${PLATFORM_ADMIN}.${SUPER_ADMIN}`,
      `${PLATFORM_ADMIN}.${APP_ACCESS}`,
    ],
  },
  {
    label: 'My Profile',
    href: '/apps/home/#/user/MyProfile',
    rules: [
      `${PLATFORM_ADMIN}.${SUPER_ADMIN}`,
      `${PLATFORM_ADMIN}.${APP_ACCESS}`,
    ],
  },
  {
    label: 'Switch Profiles',
    href: routes.switchProfile,
  },
  {
    label: 'Sign Out',
    href: routes.signOut,
  },
];